import React from 'react';

import { Spinner } from '@zillow/zrs-comet';
import { StyledSpinnerContainer } from './StyledComponents';

const SpinnerContainer = ({ customClass, ...spinnerProps }) => (
    <StyledSpinnerContainer
        className={`SpinnerContainer ${customClass}`}
        {...spinnerProps}
    >
        <Spinner {...spinnerProps} />
    </StyledSpinnerContainer>
);

export default SpinnerContainer;
